import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var CompanyNotificationType;
(function (CompanyNotificationType) {
    CompanyNotificationType["STANDARD"] = "STANDARD";
    CompanyNotificationType["CRITICAL"] = "CRITICAL";
})(CompanyNotificationType || (CompanyNotificationType = {}));
export var CompanyNotificationStatus;
(function (CompanyNotificationStatus) {
    CompanyNotificationStatus["ACTIVE"] = "ACTIVE";
    CompanyNotificationStatus["EXPIRED"] = "EXPIRED";
    CompanyNotificationStatus["SCHEDULED"] = "SCHEDULED";
})(CompanyNotificationStatus || (CompanyNotificationStatus = {}));
